<template>
  <fragment>
    <transition name="fade">
      <PdkLoading v-if="loading" />
    </transition>
    <div class="layer"></div>

    <div>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
    <PdkToTop />
  </fragment>
</template>

<script>
// var meta=null;
// fetch(process.env.BASE_URL + "metaResource.json")
//   .then((response) => response.json())
//   .then((res) => {
//        meta = res;
//   })
import PdkLoading from "@/components/PdkLoading";
import PdkToTop from "@/components/PdkToTop";

export default {
  name: "App",

  components: {
    PdkLoading,

    PdkToTop,
  },
  data: () => ({
    loading: true,
  }),

  //    metaInfo () {

  // console.log(" Vue.prototype.$metaResource",    meta );
  //     return meta;
  //   },
  beforeCreate: function () {
    this.loading = true;
  },
  updated: function () {
    this.loading = false;
  },
  created() {
    this.checkProtoco();
  },
  methods: {
    checkProtoco() {
      if (
        location.protocol !== "https:" &&
        window.location.host.toLowerCase() === "dariushgroup.com"
      ) {
        location.replace(
          `https:${location.href.substring(location.protocol.length)}`
        );
      }
    },
  },
};
</script>
<style lang="scss">
/* @import '../public/css/style-ltr.scss'; */
@font-face {
  font-family: "sansation";
  src: url("../public/fonts/sansation/Sansation_Regular.eot"); /* IE9*/
  src: url("../public/fonts/sansation/Sansation_Regular.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-IE8 */
      url("../public/fonts/sansation/Sansation_Regular.ttf")
      format("truetype"),
    /* chrome、firefox */
      url("../public/fonts/sansation/Sansation_Regular.woff")
      format("woff");
      font-weight: normal;
}
@font-face {
  font-family: "sansation";
  src: url("../public/fonts/sansation/Sansation_Light.eot"); /* IE9*/
  src: url("../public/fonts/sansation/Sansation_Light.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-IE8 */
      url("../public/fonts/sansation/Sansation_Light.ttf")
      format("truetype"),
    /* chrome、firefox */
      url("../public/fonts/sansation/Sansation_Light.woff")
      format("woff");
      font-weight: 200;
}
@font-face {
  font-family: "sansation";
  src: url("../public/fonts/sansation/Sansation_Bold.eot"); /* IE9*/
  src: url("../public/fonts/sansation/Sansation_Bold.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-IE8 */
      url("../public/fonts/sansation/Sansation_Bold.ttf")
      format("truetype"),
    /* chrome、firefox */
      url("../public/fonts/sansation/Sansation_Bold.woff")
      format("woff");
      font-weight: 500;
}

.modal-backdrop.fade.show {
  z-index: 0;
}
.profile-se{
    margin-top: 7px !important;
}
body.ltr {
  font-family: sansation !important;
  h1, h2, h3, h4, h5, h6, a, strong, label, input, button, div, .news-more span 
  , .vpd-body span, .room_price span, .reserve-explorer-item span, .eng-titles span,
.vue-slider span ,   .search-summary span
  {
    font-family: sansation !important;
  }
  // letter-spacing: 0.5px;
  direction: ltr;
  .mobile-header-middle {
    direction: ltr;

    ul#top_links {
      li {
        &:first-child {
          border-radius: 22px 0 0 22px;
        }

        &:nth-child(2) {
          border-radius: 0 22px 22px 0;
        }
      }
    }
  }
  .search-box {
    .reserve-explorer-item:first-child .reserve-explorer-tab {
      border-radius: 25px 0 0 0 !important;
    }

    .reserve-explorer-item:last-child .reserve-explorer-tab[data-v-5e7337c8] {
      border-radius: 0 25px 0 0 !important;
    }

    .custom-search-input-2 .icon {
      left: 5px;
      right: unset !important;
    }

    .vpd-input-group input {
      border-right: 1px solid #dadada !important;
      border-left: none;
    }
    .custom-search-input-2 .icon.pull-left {
      right: 8px !important;
      left: unset !important;
    }
    .panel-dropdown > input {
      padding-left: 40px;
    }
    .panel-dropdown > a {
      text-align: left;
    }
    .panel-dropdown a:after {
      right: 0 !important;
      left: auto !important;
    }
    .room {
      text-align: left;
    }
  }
  .search-summary{
    .border-left {
    border-right: 2px solid #eef1f5 !important;
    border-left: none !important;
}
.search-summary-item{
    padding-left: 40px !important;
}
.btn-side{
  text-align: right !important;
}
.btn_change[data-v-4365bc8f] {
    float: right;
}
  }
  .pardis-transparent-banner img {
    margin-right: -100px;
    margin-left: 0 !important;
}
.about-pardis-dariush .about-pardis-left .about-counter .col-lg-4:nth-child(7) .counter-item::after{
right: -50% !important;
left: unset !important;
}
.about-pardis-dariush .about-pardis-left .about-counter .first-link .counter-item::before{
  left: -50% !important;
}
.build-badge{
  direction: rtl;
  margin-left: 30px;
}

.login-form{
  margin-left: 17%;
  margin-right:0 !important;
}
.reserve-explorer-item svg.hotef {
    width: 50px !important;
}
.base-tables th:first-child {
    border-radius: 20px 0  0 0;
}
.base-tables th:last-child {
    border-radius: 0 20px   0 0;
}
.accordion-expand .icon-down-open-2 {
    left: -10px;
}
.group_mdi input:focus~label, .group_mdi input:valid~label, input:-webkit-autofill~label, .group_mdi input[type="number"]:disabled~label, .group_mdi .special-labels,
.select-text:focus~.select-label, .select-text:valid~.select-label
 {
  right: unset !important;
    left: 25px;
}
.group_mdi label{
    right: unset !important;
    left: 50px;
}
ul.list_ok li:before{
  left: unset !important;
  right: 0 !important;
}
ul#top_links li:first-child ,ul#top_links li:last-child{
    padding: 3px 15px 6px 12px !important;
    }
    .change-hf, .change-hf:hover {
    right: 16px;
    left: unset !important;
}
.form-check-input {
    margin-left: -1.25rem;
    margin-right: inherit;
}
.about-more-h::after {
  right: unset !important;
  left: -70px;
}
}
</style>
